import * as React from "react";
import { AnalyticsTrigger } from "../../helpers/analytics/analytics-trigger/analytics-trigger.mjs";
import { useLabels } from "../../helpers/label-provider/use-labels.mjs";
import { PropsChecker } from "../../helpers/props-checker/props-checker.mjs";
import { Spinner } from "../../spinner/spinner.mjs";
const Toggle = (props) => {
  return /* @__PURE__ */ React.createElement(
    PropsChecker,
    {
      componentName: "Toggle",
      componentProps: props,
      defaultValueName: "defaultChecked",
      valueName: "checked",
      onChangeNames: "onChange",
      isComponentDisabled: props.disabled || props.loading
    },
    /* @__PURE__ */ React.createElement(
      AnalyticsTrigger,
      {
        trigger: {
          callback: "onChange",
          id: ([checked]) => "Toggle - ".concat(checked ? "ON" : "OFF", " - ").concat(props.id),
          elementType: "toggle",
          elementId: props.id,
          interactionType: ([checked]) => "".concat(checked ? "select" : "deselect")
        }
      },
      /* @__PURE__ */ React.createElement(ToggleInner, { ...props })
    )
  );
};
const ToggleInner = (props) => {
  const {
    label,
    onLabel,
    input,
    id,
    labelPosition = "right",
    className,
    size,
    onChange,
    checked,
    defaultChecked,
    disabled,
    children,
    loading,
    loadingLabel,
    required,
    employee
  } = props;
  const labels = useLabels();
  const [innerChecked, setInnerChecked] = React.useState(defaultChecked || false);
  const isChecked = onChange && typeof checked !== "undefined" ? checked : innerChecked;
  const handleChange = () => {
    const nextChecked = !isChecked;
    if (disabled || loading) {
      return;
    }
    if (typeof checked === "undefined") {
      setInnerChecked(nextChecked);
    }
    if (onChange) {
      onChange(nextChecked);
    }
  };
  const getLabels = (positions) => {
    const isCurrent = positions.includes(labelPosition);
    if (!isCurrent) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("span", { className: "toggle__text toggle__text--off", "aria-hidden": !children }, children || label), onLabel && /* @__PURE__ */ React.createElement("span", { className: "toggle__text toggle__text--on", "aria-hidden": !children }, children || onLabel), loading && /* @__PURE__ */ React.createElement(Spinner, { className: "toggle__text toggle__text--loading" }));
  };
  const getSRLabel = () => {
    if (loading) {
      return loadingLabel || labels.get("loading");
    }
    return isChecked && onLabel ? onLabel : label;
  };
  function BEM() {
    const classArray = ["toggle"];
    if (labelPosition === "inside") {
      classArray.push("toggle--large");
    } else if (size) {
      classArray.push("toggle--".concat(size));
    }
    if (onLabel) {
      classArray.push("toggle--with-on-label");
    }
    if (loading) {
      classArray.push("toggle--loading");
    }
    if (employee) {
      classArray.push("toggle--employee");
    }
    classArray.push("toggle--with-label-".concat(labelPosition));
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  }
  function inputBEM() {
    const classArray = ["toggle__input"];
    if (input && input.className) {
      classArray.push(input.className);
    }
    return classArray.join(" ");
  }
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: BEM(),
      onClick: (e) => e.stopPropagation()
    },
    /* @__PURE__ */ React.createElement(
      "input",
      {
        ...input,
        type: "checkbox",
        id,
        className: inputBEM(),
        onChange: handleChange,
        checked: isChecked,
        defaultChecked: void 0,
        disabled: disabled || loading,
        "aria-required": required
      }
    ),
    /* @__PURE__ */ React.createElement("label", { htmlFor: id, className: "toggle__label" }, getSRLabel()),
    /* @__PURE__ */ React.createElement("span", { className: "toggle__inner", onClick: handleChange }, /* @__PURE__ */ React.createElement("span", { className: "toggle__indicator" }, getLabels(["inside"])), /* @__PURE__ */ React.createElement("span", { className: "toggle__label-wrapper" }, getLabels(["right", "left"])))
  );
};
export {
  Toggle
};
